import { createTheme } from '@classify/react-core-components/styles';
import { theme as defaultTheme } from '../modules/default';

function getOcTheme() {
  const muiTheme = createTheme(defaultTheme);
  return muiTheme;
}

export default getOcTheme;
